<script>

	import Author from '@/components/Author'

	function divHelper (className) {
		return {
			functional: true,
			render (h, ctx) {
				return <div class={className} {...ctx.data}>{ctx.children}</div>
			}
		}
	}

	export default {
		name: 'featuredBlogArticle',
		props: {
			entry: {
				type: Object,
				default () {
					return {}
				}
			},
			entryName: {
				type: String,
				default: 'blogEntry'
			},
			render: Function
		},
		render () {
			const { entry, entryName } = this
			if(!entry || !entry.id) {
				return null
			}
			return (
				<div class="featured-blog-article" style={{ backgroundImage: `url(${entry.leadImage})` }}>
					<div class="body">
						<container>
							{this.render && this.render({
								entry: this.entry,
								Prehead: divHelper('body__prehead'),
								Title: divHelper('body__title'),
								Intro: divHelper('body__intro'),
								Author: {
									functional: true,
									render () {
										return (
											<Author
												headshot={entry.author.headshot}
												title={`By ${entry.author.title}`}
												class="author"
											/>
										)
									}
								},
								Cta: {
									functional: true,
									render (h, ctx) {
										return (
											<div class="body__cta">
												<btn>
													<router-link to={{ name: entryName, params: { slug: entry.slug }}}>
														{ctx.children}
													</router-link>
												</btn>
											</div>
										)
									}
								}
							})}
						</container>
					</div>
				</div>
			)
		}
	}

</script>

<style lang="scss" scoped>

	@import "responsive-font";
	@import "media";

	.featured-blog-article {
		@include responsive-font(10);
		display:flex; position:relative; align-items:center; color:#fff; padding:15rem 0 12rem 0;  background-size:cover;
		@include media(small, large) {
			text-align:center; padding-bottom:6rem;
		}
		&:before {
			position:absolute; left:0; right:0; top:0; bottom:0; background:linear-gradient(to right, rgba(#000, .5) 0%, rgba(#000, .3) 30%, rgba(#000, 0) 70%); content:'';
		}
		.author {
			@include media(small, large) {
				justify-content:center;
			}
			/deep/ {
				img {
					border-radius:50%;
				}
				.title {
					color:#fff;
				}
			}
		}
	}

	.image {
		flex-grow:1; margin-right:6em;
	}

	.body {
		position:relative; width:100%;
	}

	/deep/ {
		.author {
			margin-top:1em;
			.title {
				color:rgba(#fff, .5); font-size:1.6rem;
			}
		}
		.body__prehead {
			color:#FDB913; text-transform:uppercase; font-weight:600; letter-spacing:.2em; font-size:1.2rem;
		}
		.body__title {
			font-family:'oswald'; text-transform:uppercase; line-height:1.1; font-size:4.2rem;
		}
		.body__cta {
			.btn {
				display:inline-block;
				/deep/ {
					a {
						font-size:1.6rem;
					}
				}
			}
		}
		.body__intro {
			margin:1rem 0; font-weight:400; font-size:1.8rem;
			@include media(small, large) {
				line-height:1.3;
			}
			/deep/ {
				img {
					display:none;
				}
				a {
					color:#fff;
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/FeaturedBlogArticle.vue